import Container from '~/components/atoms/Container/Container'
import { gutterTypes } from '~/components/atoms/Container/Container'
import { Col, ContainerTypes, Grid, Row } from '~/components/atoms/Grid'
import type { ImageProps } from '~/components/atoms/Image/Image'
import Image from '~/components/atoms/Image/Image'
import { BannerTheme } from '~/enums/banner-theme'

import styles from './NewsletterSignup.module.css'

export interface NewsletterSignupProps {
  testID?: string
  title: string
  body: string
  image?: ImageProps
  theme?: BannerTheme.dark
  moduleId?: string
  showImage?: boolean
}

export default function NewsletterSignup({
  testID,
  title,
  body,
  image,
  theme = BannerTheme.dark,
  moduleId,
  showImage = true,
}: NewsletterSignupProps) {
  return (
    <div className={styles[theme]} data-testid={testID} id={moduleId}>
      <Container gutters={gutterTypes.never} className="noMaxWidth">
        <Grid variant={ContainerTypes.NoGutters}>
          <Row>
            {showImage && image && (
              <Col variant="col-2/3--md">
                <div className={styles.media}>
                  <div className={styles.imageRatio}>
                    <Image
                      asset={image?.asset}
                      alt={title}
                      sizes="(max-width: 500px) 100vw, 50vw"
                    />
                  </div>
                </div>
              </Col>
            )}
            <Col variant={showImage ? 'col-1/3--md' : 'col-full-width'}>
              <div className={styles.content}>
                <div className={styles.contentInner}>
                  {/* Newsletter signup form - HubSpot form removed */}
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </Container>
    </div>
  )
}
